import { Tab, Tabs } from "@blueprintjs/core";
import { useState } from "react";
import { Trans, withTranslation } from "react-i18next";
import { getSetting } from "../Settings/InstallationSettings";

import Title from "../Structure/logo";
import ServerSelect from "../Structure/ServerSelector";
import BookingList from "./BookingList";
import RedboxIframe from "./Iframe";
import BookingStock from "./Stocks";

const BOOKING_SYSTEM_GZR = 0;
const BOOKING_SYSTEM_WEBRESA = 1;

function Bookings() {
  const [server, setServer] = useState(0);

  return (
    <div className="component-body">
      <Title icon="book" text={<Trans>bookings</Trans>} />

      <Tabs
        id="bookingmenu"
        fill={false}
        vertical={false}
        renderActiveTabPanelOnly={true}
        defaultSelectedTabId="bl" // bookings list is available whetever booking system of the server
      >
        <ServerSelect
          filter={(srv) => srv?.booking_system !== null}
          onSelect={(id, srv) => setServer(srv)}
        />

        {(server?.booking_system === BOOKING_SYSTEM_GZR ||
          (server?.booking_system === BOOKING_SYSTEM_WEBRESA &&
            getSetting("redbox url", "") === "")) && (
          <Tab
            id="bl"
            title={<Trans>bookings</Trans>}
            icon="array-date"
            panel={<BookingList server={server} />}
          />
        )}

        {server?.booking_system === BOOKING_SYSTEM_WEBRESA &&
          getSetting("redbox url", "") !== "" && (
            <Tab
              id="bl"
              title={<Trans>bookings</Trans>}
              icon="array-date"
              panel={
                <RedboxIframe
                  page="booking"
                  title={<Trans>booking management</Trans>}
                />
              }
            />
          )}

        {server?.booking_system === BOOKING_SYSTEM_WEBRESA && (
          <Tab
            id="bsto"
            title={<Trans>gestion des stocks</Trans>}
            icon="timeline-events"
            panel={<BookingStock server={server} />}
          />
        )}

        {server?.booking_system === BOOKING_SYSTEM_WEBRESA &&
          getSetting("redbox url", "") !== "" && (
            <Tab
              id="bpa"
              title={<Trans>payments</Trans>}
              icon="dollar"
              panel={
                <RedboxIframe page="payment" title={<Trans>payment</Trans>} />
              }
            />
          )}

        {server?.booking_system === BOOKING_SYSTEM_WEBRESA &&
          getSetting("redbox url", "") !== "" && (
            <Tab
              id="bst"
              title={<Trans>statistic</Trans>}
              icon="step-chart"
              panel={
                <RedboxIframe
                  page="dashboard"
                  title={<Trans>statistic</Trans>}
                />
              }
            />
          )}
      </Tabs>
    </div>
  );
}

export default withTranslation()(Bookings);
